
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_5dqaj_93",
  "variant-secondary": "awsui_variant-secondary_4c84z_5dqaj_140",
  "variant-primary": "awsui_variant-primary_4c84z_5dqaj_175",
  "variant-info": "awsui_variant-info_4c84z_5dqaj_208",
  "variant-value-large": "awsui_variant-value-large_4c84z_5dqaj_243",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_5dqaj_275",
  "variant-recovery": "awsui_variant-recovery_4c84z_5dqaj_308",
  "button": "awsui_button_4c84z_5dqaj_341",
  "color-inverted": "awsui_color-inverted_4c84z_5dqaj_376",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_5dqaj_394",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_5dqaj_401",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_5dqaj_407",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_5dqaj_413",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_5dqaj_420",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_5dqaj_427",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_5dqaj_434",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_5dqaj_441",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_5dqaj_448",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_5dqaj_456",
  "icon": "awsui_icon_4c84z_5dqaj_456"
};
  